import {MachinePolicyResource, WorkerMachineResource} from "../resources/index";
import BasicRepository from "./basicRepository";
import Client from "../client";
import {
    DeploymentTargetResource,
    ResourceCollection,
} from "client/resources";

class MachinePolicyRepository extends BasicRepository<any, any> {
    constructor(client: Client) {
        super("MachinePolicies", client);
    }
    getTemplate(): Promise<MachinePolicyResource> {
        return this.client.get(this.client.getLink("MachinePolicyTemplate"));
    }
    getMachines(machinePolicy: MachinePolicyResource): Promise<ResourceCollection<DeploymentTargetResource>> {
        return this.client.get(machinePolicy.Links["Machines"]);
    }
    getWorkers(machinePolicy: MachinePolicyResource): Promise<ResourceCollection<WorkerMachineResource>> {
        return this.client.get(machinePolicy.Links["Workers"]);
    }
}

export default MachinePolicyRepository;